import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["select", "text"]
    static values = {
        initial: String
    }

    connect() {
        // Find the last option element
        this.otherOption = this.selectTarget.options[this.selectTarget.options.length - 1];

        if (!this.otherOption) return;

        // If we have an initial value from the database, set up the 'Other' option
        if (this.initialValue && this.initialValue !== "") {
            this.otherOption.value = this.initialValue;
            this.selectTarget.value = this.initialValue;
            this.textTarget.value = this.initialValue;
            this.showInput();
        } else {
            this.hideInput();
        }
    }

    // Called when the dropdown changes
    toggle() {
        if (this.selectTarget.value === this.otherOption.value) {
            this.showInput();
            // Focus the input for better UX
            setTimeout(() => this.textTarget.focus(), 50);
        } else {
            this.hideInput();
        }
    }

    // Called as the user types in the text box
    updateValue() {
        const val = this.textTarget.value;
        this.otherOption.value = val;
        this.selectTarget.value = val;
    }

    showInput() {
        this.textTarget.classList.remove("hidden");
        this.textTarget.required = true;
    }

    hideInput() {
        this.textTarget.classList.add("hidden");
        this.textTarget.required = false;
    }
}